import { combineReducers, createStore } from 'redux';
import LoaderReducer from './Reducer/LoaderReducer';
const RootReduces = combineReducers({
    Loading: LoaderReducer
})
export const Store = createStore(RootReduces)
